import React from "react";

const Whitepaper = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "auto" }}>
      <h1 style={{ textAlign: "center", color: "#007bff" }}>
        🚀 XMiningHub (XMH) - The Future of Smart Mining
      </h1>

      <section>
        <h2>🔷 Introduction</h2>
        <p>
          In a rapidly evolving digital era, XMH emerges as the backbone of a smart mining ecosystem that integrates blockchain technology with NFTs, offering an unprecedented mining experience. XMH is set to revolutionize the mining sector by enhancing transparency, profitability, and sustainability.
        </p>
      </section>

      <section>
        <h2>🌍 Vision</h2>
        <p>
          XMiningHub aims to create a sustainable and advanced mining ecosystem leveraging artificial intelligence to dynamically direct mining power towards the most profitable pools, ensuring maximum returns for miners and investors.
        </p>
      </section>

      <section>
        <h2>💡 Why XMH?</h2>
        <ul>
          <li><strong>Intelligent Mining</strong> – Auto-adjusts mining power to maximize profitability.</li>
          <li><strong>Economic Sustainability</strong> – A fair distribution model ensures long-term stability.</li>
          <li><strong>Innovative NFT Integration</strong> – Enables investors to own tangible mining power through NFTs.</li>
          <li><strong>Dynamic Fee System</strong> – A smart mechanism that reduces transaction costs over time.</li>
        </ul>
      </section>

      <section>
        <h2>📊 Tokenomics</h2>
        <ul>
          <li><strong>Total Supply:</strong> 100,000,000 XMH</li>
          <li><strong>Investors (Presale):</strong> 40% (40,000,000 XMH)</li>
          <li><strong>Development:</strong> 25% (25,000,000 XMH)</li>
          <li><strong>Liquidity:</strong> 20% (20,000,000 XMH)</li>
          <li><strong>Rewards & Distribution:</strong> 10% (10,000,000 XMH)</li>
          <li><strong>Emergency Reserve:</strong> 5% (5,000,000 XMH)</li>
        </ul>
      </section>

      <section>
        <h2>⚡ Use Cases</h2>
        <ul>
          <li>🎟️ <strong>Mining Power Ownership via NFTs:</strong> Invest in NFTs to gain real mining power within XMiningHub.</li>
          <li>💰 <strong>Transaction & Mining Fees:</strong> Use XMH to cover mining fees and enjoy exclusive discounts.</li>
          <li>🏆 <strong>Rewards & Incentives:</strong> Earn rewards through smart mining participation and community engagement.</li>
        </ul>
      </section>

      <section>
        <h2>🚀 Conclusion</h2>
        <p>
          XMH is not just a cryptocurrency; it's a paradigm shift in smart mining. With a focus on sustainability, profitability, and innovation, we lay the foundation for the future of decentralized mining. <strong>Join the revolution – be a part of XMiningHub today!</strong>
        </p>
      </section>
    </div>
  );
};

export default Whitepaper;
